/* Sielo — comportements front (aucune dépendance externe) */
(function () {
  'use strict';

  var routes = (window.Sielo && window.Sielo.routes) || {};

  /* ---------- Utilitaires ---------- */
  function on(root, evt, sel, fn) {
    root.addEventListener(evt, function (e) {
      var el = e.target.closest(sel);
      if (el && root.contains(el)) fn(e, el);
    });
  }
  function money(cents) {
    var fmt = (window.Sielo && window.Sielo.moneyFormat) || '{{amount_with_comma_separator}} €';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return fmt
      .replace('{{amount_with_comma_separator}}', intPart + ',' + parts[1])
      .replace('{{amount}}', intPart + '.' + parts[1])
      .replace('{{amount_no_decimals}}', intPart);
  }

  /* ---------- Menu mobile ---------- */
  on(document, 'click', '[data-menu-toggle]', function (e, el) {
    var nav = document.getElementById(el.getAttribute('aria-controls'));
    if (!nav) return;
    var open = nav.classList.toggle('is-open');
    el.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* ---------- Compte à rebours ---------- */
  var countdownTimer = null;
  function startCountdowns() {
    var nodes = document.querySelectorAll('[data-countdown]');
    if (!nodes.length) return;
    if (countdownTimer) clearInterval(countdownTimer);
    function pad(n) { return String(n).padStart(2, '0'); }
    function tick() {
      var now = Date.now();
      nodes.forEach(function (node) {
        var hours = parseFloat(node.getAttribute('data-countdown')) || 24;
        var key = 'sielo-countdown-' + (node.getAttribute('data-countdown-id') || 'default');
        var end = 0;
        try { end = parseInt(window.localStorage.getItem(key) || '0', 10); } catch (err) {}
        if (!end || end < now) {
          end = now + hours * 3600e3;
          try { window.localStorage.setItem(key, String(end)); } catch (err) {}
        }
        var s = Math.max(0, Math.floor((end - now) / 1000));
        if (node.getAttribute('data-countdown-format') === 'hms') {
          node.textContent =
            pad(Math.floor(s / 3600)) + ' : ' +
            pad(Math.floor(s / 60) % 60) + ' : ' +
            pad(s % 60);
        } else {
          node.textContent =
            pad(Math.floor(s / 86400)) + 'j : ' +
            pad(Math.floor(s / 3600) % 24) + 'h : ' +
            pad(Math.floor(s / 60) % 60) + 'm : ' +
            pad(s % 60) + 's';
        }
      });
    }
    tick();
    countdownTimer = setInterval(tick, 1000);
  }

  /* ---------- Carrousel horizontal ---------- */
  on(document, 'click', '[data-scroll-target]', function (e, el) {
    var track = document.getElementById(el.getAttribute('data-scroll-target'));
    if (!track) return;
    var dir = parseInt(el.getAttribute('data-scroll-dir') || '1', 10);
    track.scrollBy({ left: dir * Math.min(track.clientWidth, 404), behavior: 'smooth' });
  });

  /* ---------- Galerie produit ---------- */
  on(document, 'click', '[data-gallery-thumb]', function (e, el) {
    var wrap = el.closest('[data-gallery]');
    if (!wrap) return;
    var main = wrap.querySelector('[data-gallery-main] img');
    var src = el.getAttribute('data-src');
    if (main && src) {
      main.setAttribute('src', src);
      main.removeAttribute('srcset');
      main.setAttribute('alt', el.getAttribute('data-alt') || '');
    }
    wrap.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
      t.setAttribute('aria-current', t === el ? 'true' : 'false');
    });
  });

  /* ---------- Coloris + formules : résolution de ce qui part au panier ----------
   * Les sélecteurs sont des blocs de section : ils vivent à côté du formulaire,
   * pas dedans — un bloc d'application peut porter son propre <form>, et des
   * formulaires imbriqués casseraient la page. Le périmètre de référence est
   * donc le conteneur [data-buybox], pas le formulaire.
   */
  function productData() {
    var node = document.querySelector('[data-variant-data]');
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (err) { return null; }
  }

  function buyboxOf(el) {
    return el.closest('[data-buybox]');
  }

  function formOf(scope) {
    return scope ? scope.querySelector('[data-product-form]') : null;
  }

  function planPosition(scope) {
    var host = scope.querySelector('[data-plan-position]') || scope;
    var pos = parseInt(host.getAttribute('data-plan-position') || '0', 10);
    return pos > 0 ? pos : 0;
  }

  function selectedOffer(scope) {
    return scope.querySelector('[data-offer][aria-checked="true"]');
  }

  function checkedSwatch(scope, role) {
    return scope.querySelector('[data-swatch="' + role + '"][aria-checked="true"]');
  }

  function optionValues(scope) {
    var values = [];
    scope.querySelectorAll('[data-swatch="main"][aria-checked="true"]').forEach(function (sw) {
      values[parseInt(sw.getAttribute('data-option-position'), 10) - 1] = sw.getAttribute('data-value');
    });
    scope.querySelectorAll('[data-option-select]').forEach(function (sel) {
      values[parseInt(sel.getAttribute('data-option-position'), 10) - 1] = sel.value;
    });
    return values;
  }

  function matchVariant(data, values) {
    for (var i = 0; i < data.variants.length; i++) {
      var v = data.variants[i];
      var ok = true;
      for (var j = 0; j < values.length; j++) {
        if (values[j] != null && v.options[j] !== values[j]) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }

  /* Variante d'un coloris donné, les autres options restant celles du bloc d'achat. */
  function variantForSwatch(data, scope, swatch, planValue) {
    if (!data) return null;
    var values = optionValues(scope);
    if (swatch) {
      values[parseInt(swatch.getAttribute('data-option-position'), 10) - 1] = swatch.getAttribute('data-value');
    }
    var pos = planPosition(scope);
    if (pos && planValue) values[pos - 1] = planValue;
    return matchVariant(data, values);
  }

  function offerPriceLabels(offer) {
    var node = offer && offer.querySelector('[data-offer-price]');
    if (!node) return null;
    var strike = node.querySelector('s');
    var compare = strike ? strike.textContent.trim() : '';
    return { price: node.textContent.replace(compare, '').trim(), compare: compare };
  }

  /*
   * Décrit exactement ce que l'ajout au panier enverra. Trois cas :
   *  - 'external' : la formule pointe un autre produit, une ligne pour ce produit ;
   *  - 'variant'  : la formule est une variante dédiée (option Formule), une ligne ;
   *  - 'split'    : la formule est un lot de la même variante, une ligne par coloris,
   *                 pour que le panier contienne réellement deux paires.
   * Le second coloris ne part en note de ligne que dans les deux premiers cas :
   * en mode 'split' il est déjà porté par la variante de la seconde ligne.
   */
  function resolveSelection(scope) {
    var data = productData();
    var form = formOf(scope);
    var offer = selectedOffer(scope);
    var units = offer ? Math.max(1, parseInt(offer.getAttribute('data-quantity') || '1', 10)) : 1;
    var isDuo = !!offer && offer.getAttribute('data-duo') === 'true';
    var packLabel = offer ? offer.getAttribute('data-pack-label') || '' : '';
    var planValue = offer ? offer.getAttribute('data-plan-value') : '';
    var idInput = form && form.querySelector('[data-variant-id]');
    var manual = offer && offer.getAttribute('data-price-manual') === 'true' ? offerPriceLabels(offer) : null;

    var plan = {
      mode: 'variant',
      isDuo: isDuo,
      units: units,
      lines: [],
      available: false,
      priceLabel: manual ? manual.price : '',
      variant: null
    };

    if (!data) {
      var qtyField = form && form.querySelector('input[name="quantity"]');
      plan.units = qtyField ? Math.max(1, parseInt(qtyField.value || '1', 10)) : 1;
      plan.available = true;
      plan.lines = [{ id: idInput ? idInput.value : null, quantity: plan.units, properties: {} }];
      return plan;
    }

    var packProps = {};
    if (packLabel) packProps[data.packLabelKey || 'Pack'] = packLabel;

    /* Formule portée par un autre produit : Shopify facture ce produit-là.
       Un pack dédié contient déjà ses deux paires, on n'en ajoute qu'une unité. */
    if (offer && offer.getAttribute('data-external-product') === 'true') {
      plan.mode = 'external';
      plan.units = isDuo ? 1 : units;
      plan.lines = [{ id: offer.getAttribute('data-external-variant'), quantity: plan.units, properties: packProps }];
      plan.available = true;
      if (!plan.priceLabel) {
        var labels = offerPriceLabels(offer);
        plan.priceLabel = labels ? labels.price : '';
      }
      return plan;
    }

    var mainSwatch = checkedSwatch(scope, 'main');
    var mainVariant = variantForSwatch(data, scope, mainSwatch, planValue);

    /* Le produit a une option Formule et la variante dédiée existe : une seule ligne,
       elle porte déjà le pack, donc une unité pour un duo. */
    if (planPosition(scope) > 0 && planValue && mainVariant) {
      plan.mode = 'variant';
      plan.variant = mainVariant;
      plan.units = isDuo ? 1 : units;
      plan.lines = [{ id: mainVariant.id, quantity: plan.units, properties: packProps }];
      plan.available = mainVariant.available;
      if (!plan.priceLabel) plan.priceLabel = money(mainVariant.price * plan.units);
      return plan;
    }

    /* Sinon la formule est un lot de la même variante : on ajoute autant de paires. */
    if (!mainVariant) {
      plan.available = false;
      plan.lines = [];
      return plan;
    }

    plan.variant = mainVariant;
    var secondSwatch = isDuo ? checkedSwatch(scope, 'second') : null;
    var secondVariant = secondSwatch ? variantForSwatch(data, scope, secondSwatch, planValue) : null;

    if (isDuo && units > 1 && secondVariant && secondVariant.id !== mainVariant.id) {
      plan.mode = 'split';
      var firstShare = Math.ceil(units / 2);
      var secondShare = units - firstShare;
      plan.lines = [
        { id: mainVariant.id, quantity: firstShare, properties: packProps },
        { id: secondVariant.id, quantity: secondShare, properties: packProps }
      ];
      plan.available = mainVariant.available && secondVariant.available;
      if (!plan.priceLabel) {
        plan.priceLabel = money(mainVariant.price * firstShare + secondVariant.price * secondShare);
      }
      return plan;
    }

    /* Duo d'un seul coloris, ou achat simple : une ligne, la quantité fait le reste. */
    plan.mode = isDuo && units > 1 ? 'split' : 'variant';
    plan.lines = [{ id: mainVariant.id, quantity: units, properties: packProps }];
    plan.available = mainVariant.available;
    if (!plan.priceLabel) plan.priceLabel = money(mainVariant.price * units);
    return plan;
  }

  /* Grise les coloris indisponibles compte tenu des autres options choisies. */
  function markSwatchAvailability(scope, data) {
    if (!data) return;
    var offer = selectedOffer(scope);
    var planValue = offer ? offer.getAttribute('data-plan-value') : '';
    scope.querySelectorAll('[data-swatch]').forEach(function (sw) {
      var variant = variantForSwatch(data, scope, sw, planValue);
      if (variant && variant.available) sw.removeAttribute('data-unavailable');
      else sw.setAttribute('data-unavailable', 'true');
    });
  }

  /* La photo principale suit le coloris de la paire principale. */
  function syncGallery(scope, data) {
    var swatch = checkedSwatch(scope, 'main');
    if (!swatch) return;
    var wrap = scope.closest('[data-gallery]') || document.querySelector('[data-gallery]');
    var main = wrap && wrap.querySelector('[data-gallery-main] img');
    if (!main) return;
    var offer = selectedOffer(scope);
    var variant = variantForSwatch(data, scope, swatch, offer ? offer.getAttribute('data-plan-value') : '');
    var src = (variant && variant.media) || swatch.getAttribute('data-media');
    if (!src || main.getAttribute('src') === src) return;
    main.setAttribute('src', src);
    main.removeAttribute('srcset');
    main.setAttribute('alt', swatch.getAttribute('data-value') || main.getAttribute('alt') || '');
    wrap.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
      t.setAttribute('aria-current', t.getAttribute('data-src') === src ? 'true' : 'false');
    });
  }

  function updateBuybox(scope) {
    if (!scope) return;
    var form = formOf(scope);
    if (!form) return;
    var data = productData();
    var plan = resolveSelection(scope);

    var idInput = form.querySelector('[data-variant-id]');
    if (idInput && plan.lines.length) idInput.value = plan.lines[0].id;

    var qty = form.querySelector('input[name="quantity"]');
    if (qty && data) qty.value = plan.units;

    var cta = form.querySelector('[data-cta-label]');
    if (cta && data) {
      if (!plan.available) cta.textContent = data.soldOutLabel;
      else if (data.showPrice === false || !plan.priceLabel) cta.textContent = data.buttonLabel;
      else cta.textContent = data.buttonLabel + ' — ' + plan.priceLabel;
    }

    var submit = form.querySelector('[type="submit"]');
    if (submit && data) {
      submit.disabled = !plan.available;
      submit.setAttribute('aria-disabled', plan.available ? 'false' : 'true');
    }

    /* Second coloris : visible pour un duo. Sa note de ligne ne sert que
       lorsque les deux paires tiennent sur une seule ligne de panier. */
    var second = scope.querySelector('[data-second-color]');
    if (second) {
      second.hidden = !plan.isDuo;
      var hidden = second.querySelector('[data-swatch-input="second"]');
      if (hidden) hidden.disabled = !(plan.isDuo && plan.mode !== 'split');
    }

    markSwatchAvailability(scope, data);
    syncGallery(scope, data);

    var sticky = document.querySelector('[data-sticky-price]');
    if (sticky && plan.priceLabel) sticky.textContent = plan.priceLabel;
  }

  function selectSwatch(el) {
    var group = el.closest('[data-swatch-group]');
    if (!group) return;
    group.querySelectorAll('[data-swatch]').forEach(function (s) {
      var isTarget = s === el;
      s.setAttribute('aria-checked', isTarget ? 'true' : 'false');
      s.setAttribute('tabindex', isTarget ? '0' : '-1');
    });
    var role = el.getAttribute('data-swatch');
    var label = group.querySelector('[data-swatch-current="' + role + '"]');
    if (label) label.textContent = el.getAttribute('data-value');
    var hidden = group.querySelector('[data-swatch-input="second"]');
    if (hidden) hidden.value = el.getAttribute('data-value');
    updateBuybox(buyboxOf(el));
  }

  on(document, 'click', '[data-offer]', function (e, el) {
    var scope = buyboxOf(el);
    if (!scope) return;
    scope.querySelectorAll('[data-offer]').forEach(function (o) {
      var isTarget = o === el;
      o.setAttribute('aria-checked', isTarget ? 'true' : 'false');
      o.setAttribute('tabindex', isTarget ? '0' : '-1');
    });
    updateBuybox(scope);
  });

  on(document, 'click', '[data-swatch]', function (e, el) { selectSwatch(el); });

  /* Flèches du clavier dans les groupes radio (coloris et formules). */
  on(document, 'keydown', '[role="radiogroup"]', function (e, group) {
    var step = 0;
    if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') step = -1;
    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') step = 1;
    if (!step) return;
    var items = [].slice.call(group.querySelectorAll('[role="radio"]'));
    if (items.length < 2) return;
    var from = items.indexOf(document.activeElement);
    if (from < 0) {
      for (var i = 0; i < items.length; i++) {
        if (items[i].getAttribute('aria-checked') === 'true') { from = i; break; }
      }
    }
    if (from < 0) from = 0;
    e.preventDefault();
    var next = items[(from + step + items.length) % items.length];
    next.focus();
    next.click();
  });

  on(document, 'change', '[data-option-select]', function (e, el) {
    updateBuybox(buyboxOf(el));
  });

  function initProductForms() {
    document.querySelectorAll('[data-buybox]').forEach(updateBuybox);
  }

  /* ---------- Quantité ---------- */
  on(document, 'click', '[data-qty-step]', function (e, el) {
    var wrap = el.closest('[data-qty]');
    if (!wrap) return;
    var input = wrap.querySelector('input');
    var step = parseInt(el.getAttribute('data-qty-step'), 10);
    var next = Math.max(1, (parseInt(input.value, 10) || 1) + step);
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Tiroir panier ---------- */
  var drawer = null;
  function getDrawer() {
    if (!drawer) drawer = document.getElementById('sielo-cart-drawer');
    return drawer;
  }
  function openDrawer() {
    var d = getDrawer();
    if (!d) { window.location.href = routes.cart || '/cart'; return; }
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var close = d.querySelector('[data-cart-close]');
    if (close) close.focus();
  }
  function closeDrawer() {
    var d = getDrawer();
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  on(document, 'click', '[data-cart-open]', function (e) { e.preventDefault(); refreshCart().then(openDrawer); });
  on(document, 'click', '[data-cart-close]', function (e) { e.preventDefault(); closeDrawer(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  function refreshCart() {
    var url = (routes.cart || '/cart') + '?section_id=cart-drawer';
    return fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById('sielo-cart-drawer');
        var current = getDrawer();
        if (fresh && current) {
          var wasOpen = current.classList.contains('is-open');
          current.innerHTML = fresh.innerHTML;
          if (wasOpen) current.classList.add('is-open');
        }
        return fetch((routes.cart || '/cart') + '.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (n) { n.textContent = cart.item_count; });
        return cart;
      })
      .catch(function () { return null; });
  }
  window.SieloRefreshCart = refreshCart;

  /* ---------- Ajout au panier en AJAX ---------- */
  on(document, 'submit', 'form[data-ajax-cart]', function (e, form) {
    e.preventDefault();
    var submit = form.querySelector('[type="submit"]');
    var box = form.querySelector('[data-form-error]');
    if (box) { box.hidden = true; box.textContent = ''; }
    /* État d'attente par classe : écraser textContent effacerait le libellé de prix. */
    if (submit) {
      submit.disabled = true;
      submit.setAttribute('aria-busy', 'true');
      submit.classList.add('is-loading');
    }
    fetch((routes.cartAdd || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(serialize(form))
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) throw new Error(data.description || data.message);
        return refreshCart().then(openDrawer);
      })
      .catch(function (err) {
        if (box) { box.hidden = false; box.textContent = err.message; }
        else window.location.href = routes.cart || '/cart';
      })
      .finally(function () {
        if (submit) {
          /* Ne pas réactiver un bouton rendu désactivé (produit épuisé). */
          submit.disabled = submit.getAttribute('aria-disabled') === 'true';
          submit.removeAttribute('aria-busy');
          submit.classList.remove('is-loading');
        }
        /* Rétablit prix, quantité et disponibilité réels après l'ajout. */
        updateBuybox(form.closest('[data-buybox]'));
      });
  });

  function serialize(form) {
    var data = new FormData(form);
    var sellingPlan = data.get('selling_plan');
    var formProps = {};
    data.forEach(function (value, key) {
      var m = key.match(/^properties\[(.+)\]$/);
      if (m && value) formProps[m[1]] = value;
    });

    /* Le plan décrit les lignes à créer : un duo à deux coloris en produit deux. */
    var scope = form.hasAttribute('data-product-form') ? form.closest('[data-buybox]') : null;
    var plan = scope
      ? resolveSelection(scope)
      : { lines: [{ id: data.get('id'), quantity: parseInt(data.get('quantity') || '1', 10), properties: {} }] };

    var lines = plan.lines.length
      ? plan.lines
      : [{ id: data.get('id'), quantity: parseInt(data.get('quantity') || '1', 10), properties: {} }];

    return {
      items: lines.map(function (line) {
        var item = { id: line.id, quantity: line.quantity };
        var props = {};
        Object.keys(formProps).forEach(function (k) { props[k] = formProps[k]; });
        Object.keys(line.properties || {}).forEach(function (k) { props[k] = line.properties[k]; });
        if (Object.keys(props).length) item.properties = props;
        if (sellingPlan) item.selling_plan = sellingPlan;
        return item;
      })
    };
  }

  /* ---------- Modification des lignes du panier ---------- */
  on(document, 'click', '[data-line-change]', function (e, el) {
    e.preventDefault();
    var line = el.getAttribute('data-line');
    var quantity = parseInt(el.getAttribute('data-line-change'), 10);
    changeLine(line, quantity);
  });
  function changeLine(line, quantity) {
    fetch((routes.cartChange || '/cart/change') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (document.body.classList.contains('template-cart')) window.location.reload();
        else refreshCart();
      });
  }

  /* ---------- Code promo ---------- */
  on(document, 'click', '[data-coupon-apply]', function (e) {
    e.preventDefault();
    var input = document.querySelector('[data-coupon-input]');
    if (!input) return;
    var code = input.value.trim();
    if (!code) { input.focus(); return; }
    window.location.href =
      '/discount/' + encodeURIComponent(code) +
      '?redirect=' + encodeURIComponent(routes.cart || '/cart');
  });

  /* ---------- Ajouts rapides (ventes complémentaires) ---------- */
  on(document, 'click', '[data-quick-add]', function (e, el) {
    e.preventDefault();
    var id = el.getAttribute('data-quick-add');
    el.disabled = true;
    fetch((routes.cartAdd || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function () { return refreshCart(); })
      .then(openDrawer)
      .finally(function () { el.disabled = false; });
  });

  /* ---------- Barre d'achat collante ---------- */
  function stickyBar() {
    var bar = document.querySelector('[data-sticky-bar]');
    var anchor = document.querySelector('[data-sticky-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { rootMargin: '-120px 0px 0px 0px' }).observe(anchor);
  }

  /* ---------- Init ---------- */
  function init() {
    startCountdowns();
    stickyBar();
    initProductForms();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', init);

  window.SieloMoney = money;
})();
